import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ─── Budget ──────────────────────────────────────────────

/** Get budget data for a project */
export async function getBudget(projectId) {
  const { data } = await axios.get(`${API}/budget/${projectId}`);
  return data;
}

/** Create a budget line item */
export async function createBudgetItem(itemData) {
  const { data } = await axios.post(`${API}/budget/items`, itemData);
  return data;
}

/** Update a budget line item — accepts full item data object */
export async function updateBudgetItem(itemId, itemData) {
  const { data } = await axios.put(`${API}/budget/items/${itemId}`, itemData);
  return data;
}

/** Delete a budget line item */
export async function deleteBudgetItem(itemId) {
  const { data } = await axios.delete(`${API}/budget/items/${itemId}`);
  return data;
}

/** Generate AI budget estimate */
export async function autoEstimateBudget(projectId, estimateData) {
  const { data } = await axios.post(`${API}/budget/auto-estimate/${projectId}`, estimateData);
  return data;
}

/** Apply AI-generated budget estimate */
export async function applyAutoEstimate(projectId, estimateData) {
  const { data } = await axios.post(`${API}/budget/apply-auto-estimate/${projectId}`, estimateData);
  return data;
}

// ─── Schedule ────────────────────────────────────────────

/** Get shoot days for a project */
export async function getShootDays(projectId) {
  const { data } = await axios.get(`${API}/schedule/shoot-days/${projectId}`);
  return data;
}

/** Create a shoot day */
export async function createShootDay(dayData) {
  const { data } = await axios.post(`${API}/schedule/shoot-days`, dayData);
  return data;
}

/** Update a shoot day — accepts full day data object */
export async function updateShootDay(dayId, dayData) {
  const { data } = await axios.put(`${API}/schedule/shoot-days/${dayId}`, dayData);
  return data;
}

/** Delete a shoot day */
export async function deleteShootDay(dayId) {
  const { data } = await axios.delete(`${API}/schedule/shoot-days/${dayId}`);
  return data;
}

/** Generate AI-powered auto-schedule */
export async function autoSchedule(projectId) {
  const { data } = await axios.get(`${API}/schedule/auto-schedule/${projectId}`);
  return data;
}

/** Apply an AI-generated schedule */
export async function applyAutoSchedule(projectId, scheduleData) {
  const { data } = await axios.post(`${API}/schedule/apply-auto-schedule/${projectId}`, scheduleData);
  return data;
}

/** Get call sheet for a shoot day */
export async function getCallSheet(dayId) {
  const { data } = await axios.get(`${API}/schedule/call-sheet/${dayId}`);
  return data;
}
